module.exports = __webpack_public_path__ + "static/media/nikol.4ec5715a.png";